import { useLocalStorage } from '@uidotdev/usehooks';

import type { FeatureFlag } from '.';

export const useFeatureFlagCompat = <T extends string>(
  flagKey: T,
): [boolean, (value: boolean) => void] => {
  try {
    return useLocalStorage<boolean>(flagKey, undefined);
  } catch (err) {
    if (err instanceof SyntaxError) {
      localStorage.removeItem(flagKey); // happens if the value is not a boolean
    }

    return [
      false,
      (_: boolean) => {
        /** TODO: Capture with Sentry */
      },
    ] as const;
  }
};

export const useFeatureFlag = useFeatureFlagCompat<FeatureFlag>;
